<p-autoComplete [(ngModel)]="filter" [readonly]="isReadOnly" [suggestions]="filterResults" placeholder="{{ 'Please Select' | translate }}">
</p-autoComplete>
<p-dialog header=" " [(visible)]="isShowQueryDialog" [modal]="true" [draggable]="false" closeIcon="pi pi-close"
  styleClass="p-dialog-lg" appendTo="body" [contentStyle]="{ overflow: 'visible'}" (onHide)="resetQueryDialog()">
  <p-accordion styleClass="cfc-collapse-container">
    <p-accordionTab [(selected)]="isShowQueryCondition">
      <div class="cfc-dialog-query-container mb-20">
        <ng-container *ngIf="conditionsTemplate">
          <ng-container *ngTemplateOutlet="conditionsTemplate"></ng-container>
        </ng-container>
      </div>
      <div class="p-d-flex p-jc-center">
        <button pButton type="button" [label]="'Cancel'|translate" class="p-button-secondary p-content-button p-mr-2"
          (click)="toggleShowQueryDialog()"></button>
        <button pButton type="button" [label]="'Search'|translate" class="p-content-button"
          (click)="submitQuery()"></button>
      </div>
    </p-accordionTab>
  </p-accordion>
  <div class="cfc-collapse-toggle-container mt-20 mb-20">
    <hr class="cfc-divider" />
    <button pButton label="{{ (isShowQueryCondition ? 'Collapse' : 'Expand') | translate }}" type="button" [icon]="
        isShowQueryCondition ? 'pi pi-arrow-up-gold' : 'pi pi-arrow-down-gold'
      " iconPos="right" class="p-button-outlined cfc-collapse-button mh-10"
      (click)="toggleShowQueryCondition()"></button>
    <hr class="cfc-divider" />
  </div>
  <!-- <p-table [paginator]="showResultTabelPage" [columns]="tableHeader" [autoLayout]="true" [rows]="5" [value]="tableVal">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns">
          {{col.header|translate}}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns">
          <ng-container *ngIf="col.header==showColLink">
            <a sigvVisitedLink href="#" class="link" (click)="selectQueryData($event, rowData[col.field])">
              {{rowData[col.field]|translate}}
            </a>
          </ng-container>
          <ng-container *ngIf="col.header!=showColLink">
            {{rowData[col.field]|translate}}
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </p-table> -->
  <div style="overflow-y: auto; height: 250px;">
    <sigv-data-table [value]="tableVal" [columns]="tableHeader" [loading]="tableLoading" [paginator]="false" [scrollable]="false">
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td *ngFor="let column of columns">
            <ng-container *ngIf="column.header==showColLink">
              <a sigvVisitedLink href="#" class="link" (click)="selectQueryData($event, rowData)">
                {{rowData[column.field]|translate}}
              </a>
            </ng-container>
            <ng-container *ngIf="column.header!=showColLink">
              {{rowData[column.field]|translate}}
            </ng-container>
          </td>
        </tr>
      </ng-template>
    </sigv-data-table>
  </div>
</p-dialog>
